module.exports = __webpack_public_path__ + "img/flusso_corsi_online_smartform.a247e5fc.png";